import React from 'react';
import { motion } from 'framer-motion';
import { IMAGES } from '../../data/images';

export default function TeamMember({ name, role, description, image, index }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.2 }}
      className="relative group"
    >
      {/* Background glow */}
      <div className="absolute -inset-4 bg-gradient-to-br from-red-500/5 to-amber-500/5 rounded-2xl blur-xl 
                    group-hover:from-red-500/10 group-hover:to-amber-500/10 transition-all duration-300" />
      
      <div className="relative bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-xl">
        {/* Image container */}
        <motion.div
          whileHover={{ scale: 1.05 }}
          className="relative w-48 h-48 mx-auto mb-6"
        >
          {/* Placeholder circle with gradient border */}
          <div className="absolute inset-0 rounded-full bg-gradient-to-br from-red-600 to-amber-500 p-1">
            <div className="w-full h-full rounded-full overflow-hidden bg-white">
              <img
                src={IMAGES.team[name.toLowerCase()]}
                alt={name}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
          
          {/* Decorative elements */}
          <div className="absolute -inset-4 bg-red-600/5 rounded-full blur-xl" />
        </motion.div>

        {/* Content */}
        <div className="text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-1">
            {name}
          </h3>
          <p className="text-red-600 font-medium mb-4">
            {role}
          </p>
          <p className="text-gray-600 leading-relaxed">
            {description}
          </p>
        </div>
      </div>
    </motion.div>
  );
}